// Gmail paused the sender's mailbox for a while (too many requests). The server saved the
// email and sends it automatically later; it answers 202 { queued: true, sendAt }.
// Returns the text to show the user, or null when the email was sent normally.
export function gmailQueuedMessage(response) {
    const data = response?.data;
    if (!data || data.queued !== true) return null;
    const at = data.sendAt ? new Date(data.sendAt) : null;
    const when = at && !Number.isNaN(at.getTime())
        ? at.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : 'in a few minutes';
    return `Gmail is busy for this mailbox right now. Your email is saved and will be sent automatically at ${when}.`;
}
